import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const DigitalArchiveCategory = ({ roles }) => {

    return (
        <M_Table entityName={'DigitalArchiveCategory'} filtersOnTable rolePermissions={roles} />
    )
}